module.exports = __webpack_public_path__ + "8b0119e9d65e3915ca0577e68d625c85.jpg";